import { render, staticRenderFns } from "./VideoButton.vue?vue&type=template&id=ef600944&scoped=true"
import script from "./VideoButton.vue?vue&type=script&lang=js"
export * from "./VideoButton.vue?vue&type=script&lang=js"
import style0 from "./VideoButton.vue?vue&type=style&index=0&id=ef600944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef600944",
  null
  
)

export default component.exports